import React from "react";

import { Form, Checkbox } from "antd";
import IneligiblePatientWarning from "../IneligiblePatientWarning";
import useConditionalValidation from "./utils/useConditionalValidation";

export const CheckboxItem = ({
  name,
  label,
  required = false,
  rules = [],
  errorMessage = "",
  shouldValidateFields = false,
  defaultValue = false,
  // Whether to seed a field-level initial value. antd lets the Form's `initialValues` win over a
  // Form.Item `initialValue`, so this `false` seed only applies as a FALLBACK when the form doesn't
  // provide one — which is what the hand-written forms and every mapped checkbox rely on to submit
  // `false` when untouched. The JSON engine turns this OFF only for an unmapped, no-default UI toggle so
  // it stays out of the submitted bundle when untouched (MVP-31021, Jehad QA Findings C / G).
  seedInitialValue = true,
  ...props
}) => {
  useConditionalValidation(name, shouldValidateFields);
  const rquiredRules = [];

  if (required)
    rquiredRules.push({
      validator: (_, value) =>
        value
          ? Promise.resolve()
          : Promise.reject(
              errorMessage ? (
                <IneligiblePatientWarning ineligibleAnswerError={new Error(errorMessage)} />
              ) : (
                new Error("")
              )
            )
    });

  return (
    <Form.Item
      rules={[{ required }, ...rquiredRules, ...rules]}
      name={name}
      valuePropName="checked"
      {...(seedInitialValue ? { initialValue: defaultValue } : {})}
      {...props}
    >
      <Checkbox>{label}</Checkbox>
    </Form.Item>
  );
};
